import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ConciliationModel } from "../../../conciliation/models/ConciliationModel"; 
import { getAllReportConciliations } from "../../../../service/conciliation/Conciliation";

export const useGetReportConciliations = (ids_dia: number[], idTipo: number) => {
  const [conciliationsList, setConciliationsList] = useState<
    ConciliationModel[]
  >([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    if (ids_dia.length === 0) {
      setConciliationsList([]);
      return;
    }
    const fetchPost = async () => {
      setLoadingRequest(true);
      const res = await getAllReportConciliations(ids_dia, idTipo)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setConciliationsList(res.rows);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [ids_dia.join(','), idTipo]); // eslint-disable-line react-hooks/exhaustive-deps

  return { conciliationsList, loadingRequest };
};
